// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--ubO5n","offers":"_7a3fb80146--offers--EMRck","layouts-entry":"_7a3fb80146--layouts-entry--lQotY","relevance":"_7a3fb80146--relevance--dYrE3"};